import React from 'react'
import { Card, CardHeader, CardBody, CardText, Container } from 'react-bootstrap';

export default function License(props) {
    return (
        <Container>
            <Card className="my-3">
                <CardHeader className="fw-bold">MIT License</CardHeader>
                <CardBody>
                    <CardText>
                        Permission is hereby granted, free of charge, to any person obtaining a copy
                        of this software and associated documentation files (the "Software"), to deal
                        in the Software without restriction, including without limitation the rights
                        to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                        copies of the Software, and to permit persons to whom the Software is
                        furnished to do so, subject to the following conditions:
                    </CardText>
                    <CardText>
                        The above copyright notice and this permission notice shall be included in all
                        copies or substantial portions of the Software.
                    </CardText>
                    <CardText>
                        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                        IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                        FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                        LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                        SOFTWARE.
                    </CardText>
                </CardBody>
            </Card>
            <Card className="my-3">
                <CardHeader className="fw-bold">Open Source Licenses</CardHeader>
                <CardBody>
                    <CardText>
                        <a href="https://opensource.org/licenses/MIT">MIT License</a>
                    </CardText>
                    <CardText>
                        <a href="https://creativecommons.org/publicdomain/zero/1.0/">CC0-1.0 License</a>
                    </CardText>
                    <CardText>
                        <a href="https://opensource.org/licenses/BSD-3-Clause">BSD 3-Clause License</a>
                    </CardText>
                    <CardText>
                        <a href="https://opensource.org/licenses/Apache-2.0">Apache License 2.0</a>
                    </CardText>
                </CardBody>
            </Card>
            <Card className="mb-3">
                <CardHeader className="fw-bold">Libraries Used</CardHeader>
                <CardBody>
                    <CardText>
                        <a href="https://reactjs.org/">React</a> - MIT License
                    </CardText>
                    <CardText>
                        <a href="https://react-bootstrap.github.io/">React Bootstrap</a> - MIT License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/adobe/css-tools">Adobe CSS Tools</a> - MIT License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/bcoe/v8-coverage">V8 Coverage</a> - MIT License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/csstools/normalize.css">Normalize.css</a> - CC0-1.0 License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/jridgewell/sourcemap-codec">Sourcemap Codec</a> - MIT License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/react-pdf">React PDF</a> - MIT License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/xtuc/ieee754">IEEE754</a> - BSD-3-Clause License
                    </CardText>
                    <CardText>
                        <a href="https://github.com/xtuc/long">Long</a> - Apache-2.0 License
                    </CardText>
                </CardBody>
            </Card>
        </Container>
    )
}
